import styled from '@emotion/styled'
import { media } from '@dfds-ui/theme'

import { AspectImage } from '../Image'
import HeroStripes from './Stripes'

const ImageWrapper = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  overflow: hidden;

  ${media.greaterThan('l')`
    position: absolute;
  `}
`

const HeroImage = (props) => {
  return (
    <ImageWrapper data-tag="imagewrapper">
      <AspectImage
        imageBehaviour="cover"
        aboveTheFold={true}
        fetchPriority="high"
        {...props.image}
      />
      <HeroStripes />
    </ImageWrapper>
  )
}

export default HeroImage
